<template>
  <div class="tag-list">
    <TagList :tags="tags" class="tag-list__tags" />
    <div class="tag-list__actions actions">
      <button
        type="button"
        @click="startEditTags"
        class="actions__item icon-button"
      >
        <i class="fa fa-pencil"></i>
      </button>
      <button
        type="button"
        @click="deleteTags"
        class="actions__item icon-button"
      >
        <i class="fa fa-trash"></i>
      </button>
    </div>
    <TagFinder
      v-if="isTagFinderShown"
      :selected="tags"
      :autoSelectAncestors="false"
    />
  </div>
</template>

<script>
import TagList from '../../../components/TagList.vue';
import TagFinder from '../../../components/TagFinder/TagFinder.vue';

export default {
  name: 'AdPostEditorTagList',
  components: { TagList, TagFinder },
  props: {
    index: {
      type: Number,
      required: true,
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isTagFinderShown: false,
    };
  },
  mounted() {
    bus.$on('done-tag-finder', (tags) => {
      // 他のコンポーネントTagFinderのイベントを拾って自分を更新しないようにする
      if (!this.isTagFinderShown) return;
      this.isTagFinderShown = false;
      this.$emit('edit-tags', { index: this.index, tags });
    });
    bus.$on('close-tag-finder', () => {
      this.isTagFinderShown = false;
    });

    // 新規追加時は最初からTagFinderを開く
    if (this.tags.length === 0) {
      this.startEditTags();
    }
  },
  methods: {
    async startEditTags() {
      this.isTagFinderShown = true;
    },
    deleteTags() {
      this.$emit('delete-tags', { index: this.index });
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-list {
  display: flex;
  align-items: center;

  &__actions {
    align-self: flex-end;

    &:nth-child(n + 2) {
      margin-left: 8px;
    }
  }
}

.actions {
  display: flex;
  align-items: center;

  &__item {
    flex: 0 0 auto;
  }
}

.icon-button {
  border: 0;
  background-color: transparent;
  color: #555;

  &:hover {
    cursor: pointer;
    color: #333;
  }

  i {
    font-size: 18px;
  }
}
</style>
